<template>
    <v-content :class="`account-info`" v-if="user" id="account-informations-personnelles">
        <h2>
            <typo name="title-30-normal"> Informations personnelles </typo>
        </h2>
        <sep name="M"></sep>
        <v-card elevation="0">
            <v-card-text>
                <v-form ref="form" class="form" v-model="valid">
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="values.firstName"
                                    class="required"
                                    label="Prénom*"
                                    :rules="[required]"
                                />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    v-model="values.lastName"
                                    class="required"
                                    label="Nom*"
                                    :rules="[required]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="values.function"
                                    class="required"
                                    :label="isFunctionRequired ? 'Fonction*' : 'Fonction'"
                                    :rules="isFunctionRequired ? [required] : []"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="values.email"
                                    label="Email*"
                                    hint="Adresse email non modifiable, utilisée pour recevoir les alertes veille conventionnelle et Actualité Sociale"
                                    :persistent-hint="true"
                                    :disabled="true"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="values.phone"
                                    required
                                    label="Téléphone"
                                    :rules="[phone]"
                                />
                            </v-col>
                            <v-col>
                                <account-input-territories v-model="values.department" />
                            </v-col>
                        </v-row>
                        <div class="actions">
                            <action name="main" @click="validate()">Valider</action>
                        </div>
                        <typo class="legend" name="body-12-normal">
                            <i>Les champs marqués d’une * sont obligatoires</i>
                        </typo>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
import Vue from "vue";
import AccountInputTerritories from "./AccountInputTerritories.vue";
import { required, phone } from "src/utils/vform-rules";
import userMixin from "src/mixins/user";
import { EventBus } from "src/bus/eventBus";
import scrollManager from "src/components/convention/managers/scrollManager";
import { isArray } from "lodash";

export default Vue.extend({
    props: ["user"],
    components: { AccountInputTerritories },
    data() {
        return {
            valid: true,
            isSubmitting: false,
            required: required,
            phone: phone,
            values: {
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                function: this.user.function,
                phone: this.user.phone,
                email: this.user.email,
                department: this.user.department,
            },
        };
    },
    mixins: [userMixin],
    mounted() {
        EventBus.$on("account:incomplete", () => {
            scrollManager.scrollToId("account-informations-personnelles");
            this.$refs.form.validate();
            EventBus.$emit("alert:error", {
                message:
                    "Veuillez completer le formulaire des 'Informations personnelles' pour pouvoir accèder au site.",
            });
        });
    },
    computed: {
        isFunctionRequired() {
            return (
                isArray(this.user.requiredFields) &&
                this.user.requiredFields.indexOf("function") > -1
            );
        },
    },
    methods: {
        async validate() {
            if (this.$refs.form.validate()) {
                try {
                    this.isSubmitting = true;
                    this.updateInfo(this.values);
                    EventBus.$emit("alert:success", {
                        message: "Votre modification a bien été prise en compte",
                    });
                } catch (e) {
                    EventBus.$emit("alert:error", {
                        message:
                            "Une erreur technique est rencontrée. Veuillez contacter le service client Diode.",
                    });
                } finally {
                    this.isSubmitting = false;
                }
            }
        },
        onSnackbarClose() {
            this.snackbar = null;
        },
    },
});
</script>

<style lang="sass" scoped>
.form
    max-width: 700px
    margin: 0

.actions
    display: flex
    justify-content: flex-start

.legend
    margin-top: $grid-gutter
    display: inline-block
</style>
